import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const addDocumentRequestMutation = gql`
  mutation addDocumentRequest(
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $personId: String!
    $emailSubject: String!
    $requestMessage: String!
    $documentType: String!
    $documentSection: DocumentRequestSectionType!
    $agentComment: String!
    $internalComment: String!
  ) {
    addDocumentRequest(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      personId: $personId
      emailSubject: $emailSubject
      requestMessage: $requestMessage
      documentType: $documentType
      documentSection: $documentSection
      agentComment: $agentComment
      internalComment: $internalComment
    )
  }
`

export enum SectionName {
  identity = 'identity',
  credit = 'credit',
  income = 'income',
  residential = 'residential',
  organisation = 'organisation',
  financial = 'financial',
}

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  personId: string
  emailSubject: string
  requestMessage: string
  documentType: string
  documentSection: SectionName
  agentComment: string
  internalComment: string
}

export type AddDocumentRequestData = {
  addDocumentRequest: string | unknown
}

export const useAddDocumentRequestMutation: WrappedMutation<
  AddDocumentRequestData,
  MutationVars
> = () =>
  useMutation<AddDocumentRequestData, MutationVars>(addDocumentRequestMutation, {
    client: agentClient,
  })
